import { auditReports } from '@mi-front/api-clients';
import { QueryView } from '@mi-front/ui';
import { Box } from '@mui/material';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import { Page } from '../../../../../../components/page/Page';
import { ReportDefinitionsBreadcrumbs } from '../../../../components/breadcrumbs';
import { reportNameMessages } from '../../constants';
import { CreateButton } from '../update/components/actions/CreateButton';
import { ReportDefinitionList } from './ReportDefinitionList';

export function ReportDefinitionListPage() {
  const { $t } = useIntl();
  const params = useParams<{ reportType: string }>();

  const reportType = params.reportType;
  const definitionsQuery = auditReports.useListReportDefinition({
    reportType,
  });

  const title = $t({
    id: 'audit.reportDefinitionList.title',
    defaultMessage: 'Plantillas de reporte',
  });

  const reportNameMessage = reportNameMessages[reportType];
  const reportName = reportNameMessage ? $t(reportNameMessage) : reportType;

  return (
    <Page htmlTitle={title}>
      <Page.Header
        title={
          <>
            {title}: {reportName && <span style={{ opacity: 0.7 }}>{reportName}</span>}
          </>
        }
        breadcrumbs={<ReportDefinitionsBreadcrumbs />}
        actions={
          <Box display="flex" gap={2}>
            <CreateButton reportType={reportType} />
          </Box>
        }
      />
      <Page.Content>
        <QueryView query={definitionsQuery}>
          {(definitions) => (
            <ReportDefinitionList definitions={definitions} reportType={reportType} />
          )}
        </QueryView>
      </Page.Content>
    </Page>
  );
}
